module.exports = __webpack_public_path__ + "static/media/goLast.aeae477f.svg";